module.exports = __webpack_public_path__ + "static/media/Mnist-Mockup.5d70632b.png";